import React from "react";
import { useDispatch } from "react-redux";
import { transportListTitles } from "../../Constants/tableTitles/ListTableTitle/transportList.titles";
import {
  useGetTransport,
  useRemoveTransport,
} from "../../hooks/transportHook/transport.hooks";
import { transformTransportListTableData } from "../../Services/transformer/transformTransportListTableData";
import { ListTable } from "../Table/listTable/listTable";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { EditTransportModal } from "./EditTransportModal";
import { RemoveTransportModal } from "./RemoveTransportModal";
import { getValue } from "../../utils/object.utils";

export const TransportList = () => {
  const dispatch = useDispatch();

  const [openRemoveModal, setOpenRemoveModal] = React.useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);

  const { isLoading: isTransportLoading, data: transportsData } =
    useGetTransport();

  const { isLoading: isRemoving, mutate: removeTransport } = useRemoveTransport(
    {
      onSuccess: () => {
        dispatch(setSuccessMessage("Transport removed successfully."));
        setOpenRemoveModal(false);
      },
      onError: (error: Error) => {
        dispatch(setErrorMessage(parseApiError(error)));
      },
    }
  );

  const [selectedTransportToRemove, setSelectedTransportToRemove] =
    React.useState<any>(null);

  const [selectedTransportToEdit, setSelectedTransportToEdit] =
    React.useState<any>(null);

  const handleTransportRemove = () => {
    const transportId = getValue(selectedTransportToRemove, "id");

    if (!transportId) return null;

    removeTransport(transportId);
  };

  return (
    <div>
      <ListTable
        titles={transportListTitles}
        data={transportsData}
        isDataLoading={isTransportLoading}
        transformFn={transformTransportListTableData}
        moreOptons={{
          onEdit: (data: any) => {
            setSelectedTransportToEdit(data);
            setOpenEditModal(true);
          },
          onRemove: (data: any) => {
            setSelectedTransportToRemove(data);
            setOpenRemoveModal(true);
          },
        }}
      />
      <RemoveTransportModal
        open={openRemoveModal}
        handleTransportRemove={handleTransportRemove}
        onClose={() => {
          setOpenRemoveModal(false);
        }}
        selectedTransportToRemove={selectedTransportToRemove}
        isProcessingConfirmation={isRemoving}
      />

      <EditTransportModal
        selectedTransport={selectedTransportToEdit}
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
        }}
      />
    </div>
  );
};
